import React from 'react'

const HomeFaq = () => {
    return (
        <>

            <section className="section-faq" style={{ overflow: "hidden", marginTop:"-104px" }}>
                <div className="position-relative z-1">
                    <div className="section-space section-space-bottom-huge">
                        <div className="container">
                            <div className="row gy-5 align-items-center align-items-lg-start">
                                <div className="col-lg-6">
                                    <div className="faq-content">
                                        <div className="section-content-block">
                                            <span className="section-tag">Frequently Asked Questions</span>
                                            <h2 className="section-title">
                                                <h2 className="section-title is-text-dark">Frequently Asked Questions </h2>
                                            </h2>
                                        </div>
                                        <div className="faq-accordion mt-5" id="accordionExample">
                                            <div className="accordion-item accordion-item-1">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                        Highlights of our Transport Services?
                                                    </button>
                                                </h2>
                                                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">

                                                        <div className="row mb-4">
                                                            <ul className="col-auto content-list content-list-1">
                                                                <li>Parcel load movement</li>
                                                                <li>Full truck load services </li>
                                                                <li> Secondary transportation and distribution </li>
                                                                <li> Warehousing and services </li>

                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item accordion-item-1">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                        Specialties of Our Relocation Services ?
                                                    </button>
                                                </h2>
                                                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <div className="row mb-4">
                                                            <ul className="col-auto content-list content-list-1">
                                                                <li> Timely and Cost –effective </li>
                                                                <li> Experienced and professional assistance </li>
                                                                <li> Customized containers </li>
                                                                <li> Secure and hassle-free </li>
                                                                <li> truck carrier services </li>
                                                                <li> Logistics services and solutions </li>
                                                                <li> Distribution and freight management </li>
                                                                <li> Government Aproved </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        {/* FAQ Accordion */}
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="faq-image-block">
                                        <div className="image-block">
                                            <img src="assets/images/faq-img-1.png" alt="about-img-1" width={457} height={539} className="animate-bottom-to-top img-fluid rounded" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                                        </div>
                                        {/* <div className="image-block">
                                            <img src="assets/images/faq-img-2.png" alt="about-img-1" width={315} height={291} className="animate-top-to-bottom img-fluid rounded" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                                        </div> */}
                                        <img src="assets/images/faq-bg-element-1.png" alt="dot-1" width={292} height={379} className="faq-shape faq-shape-1 img-fluid" />
                                        <img src="assets/images/abstract/dot-1.svg" alt="dot-1" width={198} height={93} className="animate-bottom-to-top faq-shape faq-shape-2 img-fluid" style={{ translate: 'none', rotate: 'none', scale: 'none', transform: 'translate(0px, 0px)', opacity: 1 }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src="assets/images/abstract/world-globe-orange.svg" alt="world-globe-orange" width={271} height={540} className="faq-globe" />
                </div>
            </section>


        </>
    )
}

export default HomeFaq